import React                from 'react';
import {ModalBox}           from '../../ModalBox.js';
import Translations         from '../../../utils/Translations';
import {generateKey}        from '../../../utils/CommonUtils.js';
import PropTypes            from 'prop-types';
import VXButton             from '../../SimpleElements/VXButton/VXButton.js';
import {VXButtonLineConfig} from '../../SimpleElements/VXButton/VXButtonConfig.js';
import {COLOR_TYPE_SPECIAL} from '../../SimpleElements/VXButton/ButtonHelper.js';

function TicketBoughtModalBox({buyResult: {isBought, isFree}, closeModal}) {
    let content = null;
    if (isFree) {
        if (isBought) {
            content = <>
                <i className="icon -icon-bell-full ticket-modalbox__icon" />
                <div className="ticket-modalbox__headline">{Translations.get('cam_shows.ticket-notification--on__headline')}</div>
                <div className="ticket-modalbox__text">{Translations.get('cam_shows.ticket-notification--on__text')}</div>
            </>;
        } else {
            content = <>
                <i className="icon -icon-bell-off-full ticket-modalbox__icon" />
                <div className="ticket-modalbox__headline">{Translations.get('cam_shows.ticket-notification--off__headline')}</div>
                <div className="ticket-modalbox__text">{Translations.get('cam_shows.ticket-notification--off__text')}</div>
            </>;
        }
    } else {
        content =
                <span className="ticket-modalbox__headline">{isBought ? Translations.get('cam_shows.ticket-saved--modal') : Translations.get('common.something-went-wrong')}</span>;
    }

    return (
            <ModalBox key={generateKey('ticket-modalbox', 0)}
                      initialWidth={400}
                      initialHeight={240}
                      onClose={closeModal}
                      modalClassName={'ticket-modalbox'}>
                <div className="ticket-modalbox__container">
                    {content}
                    <div className="ticket-modalbox__button-container">
                        <VXButton color={COLOR_TYPE_SPECIAL} line1={[new VXButtonLineConfig('Verstanden')]} onClick={closeModal} />
                    </div>
                </div>
            </ModalBox>
    );
}

TicketBoughtModalBox.propTypes = {
    buyResult:  PropTypes.object,
    closeModal: PropTypes.func,
};

export default TicketBoughtModalBox;
